import { camelize } from '../support/strings';

class Component
{
    constructor(element, props)
    {
        this.element = element;
        this.props   = Object.assign(this.parseProps(), props);
    }

    parseProps()
    {
        const props = this.getDefaultProps();

        if (this.element)
        {
            let attribute, name, value;

            for (let i = 0, len = this.element.attributes.length; i < len; i++)
            {
                attribute = this.element.attributes[i];
                value = attribute.value;
                name = attribute.name.match(/^data-(.*)/);

                // No match.
                if (!name)
                {
                    continue;
                }

                if (value.match(/^(true|false|[0-9]+)$/))
                {
                    value = eval(value);
                }

                props[camelize(name[1])] = value;
            }
        }

        return props;
    }

    getDefaultProps()
    {
        return {};
    }

    empty(element)
    {
        // Default to the main element if none passed.
        if (typeof element === typeof undefined)
        {
            element = this.element;
        }

        if (element)
        {
            while (element.firstChild)
            {
                element.removeChild(element.lastChild);
            }
        }
    }
}


export default Component;